import { Outlet } from "react-router-dom";
import SideMenu from "@/components/layout/Header/Side_Menu";

const DashboardLayout = () => {
  return (
    <div
      className="grid grid-cols-1 gap-3 lg:grid-cols-5 transition-colors duration-200"
      style={{ backgroundColor: "var(--background-color)" }}>
      <SideMenu />
      <div className="col-span-4 py-4">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
